import { render, staticRenderFns } from "./WorkflowFormModal.vue?vue&type=template&id=5b3fa591&scoped=true"
import script from "./WorkflowFormModal.vue?vue&type=script&lang=js"
export * from "./WorkflowFormModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFormModal.vue?vue&type=style&index=0&id=5b3fa591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3fa591",
  null
  
)

export default component.exports